// /settings/view — «Вид»: плотность таблиц на этом устройстве (ux.md «Табеля», разделы 6 и 11).
import { createFileRoute } from '@tanstack/react-router';
import { ViewSettingsPage } from '../../../features/settings/ViewSettingsPage.tsx';

export const Route = createFileRoute('/_app/_settings/settings/view')({
  staticData: { crumb: 'Вид' },
  component: ViewSettingsPage,
});
